import { authManager } from '../auth-manager.js';

export function renderLabsView(container, syncManager) {
  // Admin Guard: Ensure only admin can view this page
  if (!authManager.isAdmin()) {
    syncManager.showToast('Acesso restrito para administradores.', 'warning');
    window.location.hash = '#notas';
    return;
  }

  container.innerHTML = `
    <div class="section-header" style="margin-bottom: 1.25rem;">
      <div>
        <div style="display: inline-flex; align-items: center; gap: 0.35rem; background: #FEF3C7; color: #B45309; padding: 0.2rem 0.6rem; border-radius: var(--radius-pill); font-size: 0.72rem; font-weight: 700; margin-bottom: 0.35rem; text-transform: uppercase;">
          <span class="material-symbols-outlined" style="font-size: 14px;">science</span>
          Laboratório Experimental (Admin)
        </div>
        <h2 class="section-title" style="margin: 0; font-size: clamp(1.35rem, 5vw, 1.75rem); font-weight: 800; color: #111827; line-height: 1.2;">
          Labs & Experimentos
        </h2>
        <p class="section-subtitle" style="margin: 0.2rem 0 0 0; font-size: 0.85rem; color: #64748B;">
          Ambiente de testes para novas tecnologias, inteligência artificial e protótipos de produto.
        </p>
      </div>
    </div>

    <!-- Labs Experiments Grid -->
    <div class="labs-grid" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(290px, 1fr)); gap: 1.25rem; margin-bottom: 2.5rem;">
      
      <!-- Experiment 1: Product & Shelf Label Scanner -->
      <div class="chart-card" style="padding: 1.5rem; display: flex; flex-direction: column; justify-content: space-between; border: 1px solid var(--color-border); background: #FFFFFF;">
        <div>
          <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 0.85rem;">
            <div style="width: 44px; height: 44px; border-radius: 0.85rem; background: #ECFDF5; border: 1px solid #A7F3D0; display: flex; align-items: center; justify-content: center; color: #047857;">
              <span class="material-symbols-outlined" style="font-size: 24px;">barcode_scanner</span>
            </div>
            <span style="background: #ECFDF5; color: #047857; font-size: 0.72rem; font-weight: 700; padding: 0.2rem 0.55rem; border-radius: var(--radius-pill); text-transform: uppercase;">
              🧪 Ativo / PoC
            </span>
          </div>

          <h3 style="font-size: 1.15rem; font-weight: 800; color: #111827; margin: 0 0 0.4rem 0;">
            Scanner de Produtos & Gôndola
          </h3>
          
          <p style="font-size: 0.85rem; color: #64748B; line-height: 1.5; margin: 0 0 1.25rem 0;">
            Leitura em tempo real de código de barras 1D (EAN) e fotos de etiquetas de prateleira com comparativo automático de preços históricos.
          </p>
        </div>

        <button class="btn btn-primary" id="btn-open-product-scanner" style="width: 100%; padding: 0.75rem 1rem; font-weight: 700; font-size: 0.875rem; display: flex; align-items: center; justify-content: center; gap: 0.4rem; border-radius: var(--radius-pill);">
          <span class="material-symbols-outlined" style="font-size: 18px;">qr_code_scanner</span>
          Abrir Scanner de Produtos
        </button>
      </div>

      <!-- Experiment 2: Gemini Vision Multimodal OCR (Active / IA) -->
      <div class="chart-card" style="padding: 1.5rem; display: flex; flex-direction: column; justify-content: space-between; border: 1px solid var(--color-border); background: #FFFFFF;">
        <div>
          <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 0.85rem;">
            <div style="width: 44px; height: 44px; border-radius: 0.85rem; background: #EFF6FF; border: 1px solid #BFDBFE; display: flex; align-items: center; justify-content: center; color: #2563EB;">
              <span class="material-symbols-outlined" style="font-size: 24px;">psychology</span>
            </div>
            <span style="background: #EFF6FF; color: #2563EB; font-size: 0.72rem; font-weight: 700; padding: 0.2rem 0.55rem; border-radius: var(--radius-pill); text-transform: uppercase; display: inline-flex; align-items: center; gap: 0.35rem;">
              <span>✨ Ativo / IA</span>
              <span class="badge-pro"><span class="material-symbols-outlined">diamond</span>PRO</span>
            </span>
          </div>

          <h3 style="font-size: 1.15rem; font-weight: 800; color: #111827; margin: 0 0 0.4rem 0;">
            IA Gemini Vision (Multimodal)
          </h3>
          
          <p style="font-size: 0.85rem; color: #64748B; line-height: 1.5; margin: 0 0 1.25rem 0;">
            Leitura multimodal de etiquetas de gôndola, extração instantânea de preços e normalização semântica do nome de produtos.
          </p>
        </div>

        <button class="btn btn-primary" id="btn-open-ai-scanner" style="width: 100%; padding: 0.75rem 1rem; font-weight: 700; font-size: 0.875rem; display: flex; align-items: center; justify-content: center; gap: 0.4rem; border-radius: var(--radius-pill);">
          <span class="material-symbols-outlined" style="font-size: 18px;">auto_awesome</span>
          Abrir Scanner com IA
        </button>
      </div>

      <!-- Experiment 3: Recategorização Global -->
      <div class="chart-card" style="padding: 1.5rem; display: flex; flex-direction: column; justify-content: space-between; border: 1px solid var(--color-border); background: #FFFFFF;">
        <div>
          <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 0.85rem;">
            <div style="width: 44px; height: 44px; border-radius: 0.85rem; background: #FFF7ED; border: 1px solid #FFEDD5; display: flex; align-items: center; justify-content: center; color: #EA580C;">
              <span class="material-symbols-outlined" style="font-size: 24px;">category</span>
            </div>
            <span style="background: #FFF7ED; color: #EA580C; font-size: 0.72rem; font-weight: 700; padding: 0.2rem 0.55rem; border-radius: var(--radius-pill); text-transform: uppercase;">
              ⚠️ Manutenção
            </span>
          </div>

          <h3 style="font-size: 1.15rem; font-weight: 800; color: #111827; margin: 0 0 0.4rem 0;">
            Reorganizar Base de Dados
          </h3>
          
          <p style="font-size: 0.85rem; color: #64748B; line-height: 1.5; margin: 0 0 1.25rem 0;">
            Re-processa todos os cupons fiscais salvos localmente e aplica a nova taxonomia e as regras do Dicionário Global.
          </p>
        </div>

        <button class="btn btn-secondary" id="btn-global-recategorize" style="width: 100%; padding: 0.75rem 1rem; font-weight: 700; font-size: 0.875rem; display: flex; align-items: center; justify-content: center; gap: 0.4rem; border-radius: var(--radius-pill); color: #EA580C; border-color: #EA580C;">
          <span class="material-symbols-outlined" style="font-size: 18px;">autorenew</span>
          Recategorizar Tudo
        </button>
      </div>

    </div>
  `;

  // Attach button actions
  const btnOpenScanner = container.querySelector('#btn-open-product-scanner');
  if (btnOpenScanner) {
    btnOpenScanner.addEventListener('click', () => {
      window.location.hash = '#scanner-produto';
    });
  }

  const btnOpenAIScanner = container.querySelector('#btn-open-ai-scanner');
  if (btnOpenAIScanner) {
    btnOpenAIScanner.addEventListener('click', () => {
      window.location.hash = '#scanner-ai';
    });
  }

  const btnGlobalRecat = container.querySelector('#btn-global-recategorize');
  if (btnGlobalRecat) {
    btnGlobalRecat.addEventListener('click', async () => {
      if (!confirm('Isso vai re-processar todas as notas e pode levar alguns segundos. Deseja continuar?')) return;
      
      const originalText = btnGlobalRecat.innerHTML;
      btnGlobalRecat.innerHTML = '<span class="material-symbols-outlined spin" style="font-size: 18px;">sync</span> Processando...';
      btnGlobalRecat.disabled = true;
      
      try {
        const { recategorizeNotaAsync } = await import('../categorizer.js');
        
        const token = authManager.getToken();
        const res = await fetch('/api/admin/all-notas', {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        
        if (!res.ok) throw new Error('Falha ao buscar notas do servidor');
        const notas = await res.json();
        
        if (!notas || notas.length === 0) {
          syncManager.showToast('Nenhuma nota encontrada no servidor.', 'info');
          return;
        }

        let count = 0;
        for (const nota of notas) {
          // Process locally
          const updatedNota = await recategorizeNotaAsync(nota);
          
          // Send back to server
          await fetch('/api/admin/notas', {
            method: 'PUT',
            headers: { 
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` 
            },
            body: JSON.stringify(updatedNota)
          });
          
          count++;
          btnGlobalRecat.innerHTML = `<span class="material-symbols-outlined spin" style="font-size: 18px;">sync</span> Processando... ${count}/${notas.length}`;
        }
        
        syncManager.showToast(`Sucesso! ${count} notas globais re-categorizadas.`, 'success');
      } catch (err) {
        console.error('Erro na recategorização global:', err);
        syncManager.showToast('Erro ao recategorizar a base global.', 'error');
      } finally {
        btnGlobalRecat.innerHTML = originalText;
        btnGlobalRecat.disabled = false;
      }
    });
  }
}
